// extracted by mini-css-extract-plugin
export default {"onUs":"FailureScreen_onUs__Rpicp"};